import find from "lodash/find";
/**
 * @description Detects potential infinite loops
 * @usage ```
 * const checkLoop = MiscUtils.detectInfiniteLoop();
 * while (true) {
 *  checkLoop();
 *  ...
 * }
 * ```
 */
export const detectInfiniteLoop = (maxIterations = 1000) => {
  let count = 0;
  return () => {
    if (count++ > maxIterations) {
      throw new Error('Potential infinite loop detected');
    }
  };
};


export const setSessionItemWithExpiry = (key: string, value: any, ttlMs: number) => {
  const now = Date.now();
  const item = {
    value,
    expiry: now + ttlMs
  };
  sessionStorage.setItem(key, JSON.stringify(item));
}

export const getSessionItemWithExpiry = (key: string) => {
  const itemStr = sessionStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item = JSON.parse(itemStr);
    if (Date.now() > item.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }
    return item.value;
  } catch (e) {
    sessionStorage.removeItem(key);
    return null;
  }
}

/**
 * @description Gets a translation if it exists, otherwise returns undefined
 * @param t The translation function from useTranslation hook
 * @param key The translation key to check
 * @returns The translated string if the key exists, undefined otherwise
 * @usage ```
 * const { t } = useTranslation();
 * const tooltip = getTranslationIfExists(t, 'requests.status.vacation.approved');
 * <WorkDayStatusChip tooltip={tooltip} />
 * ```
 */
export const getTranslationIfExists = (t: (key: string) => string, key: string): string | undefined => {
  if (!key) return undefined;
  
  const translation = t(key);
  // If translation exists, it will be different from the key
  // If translation doesn't exist, t() returns the key itself
  return translation !== key ? translation : undefined;
}

export const findOptionFromSettings = (optionsArray: any[], code: string | undefined) => {
  if (!code) return undefined;
  let match = find(optionsArray, { code });
  if (match) {
    return match.description || code;
  }
  return code;
}